import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { AllCMSPageFields } from '@/cms/fields/mappers/common'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import { getCatalogueTypeByPublicationCode } from '@/scopes/common/domain/functions/catalogues'
import { Configuration } from '@/scopes/common/domain/types/configuration'
import { MetaDescriptionResolver } from '@/scopes/common/domain/types/meta-data'
import { IntlShape } from 'react-intl'

interface DestinationMetaDescriptionResolverDependencies {
  config: Configuration
  cmsFields: AllCMSPageFields
  intl: IntlShape
}

const PAGE_DESCRIPTION_TRANSLATION_KEY: Record<string, Record<Exclude<CatalogueType, CatalogueType.None>, string>> = {
  [TEMPLATE_NAMES.CountryPage]: {
    [CatalogueType.Summer]: 'destination_default_page_description_country_summer',
    [CatalogueType.Winter]: 'destination_default_page_description_country_winter',
  },
  [TEMPLATE_NAMES.RegionPage]: {
    [CatalogueType.Summer]: 'destination_default_page_description_region_summer',
    [CatalogueType.Winter]: 'destination_default_page_description_region_winter',
  },
  [TEMPLATE_NAMES.CityPage]: {
    [CatalogueType.Summer]: 'destination_default_page_description_city_summer',
    [CatalogueType.Winter]: 'destination_default_page_description_city_winter',
  },
}

export function createCmsDestinationMetaDescriptionResolver({
  config,
  cmsFields,
  intl,
}: DestinationMetaDescriptionResolverDependencies): MetaDescriptionResolver {
  return {
    resolve: () => {
      const catalogueType = getCatalogueTypeByPublicationCode(config.publicationCode)

      if (catalogueType === CatalogueType.None) {
        return undefined
      }

      const destinationName = cmsFields['DestinationPage.productName']

      if (!destinationName) {
        return undefined
      }

      const translationKey = PAGE_DESCRIPTION_TRANSLATION_KEY[cmsFields.template]?.[catalogueType]
      const description = intl.formatMessage(
        { id: translationKey, defaultMessage: '' },
        { destinationName },
      )

      return description || undefined
    },
  }
}
